import React from "react"

const CATEGORY_CONFIG = {
  structured: {
    label: "STRUCTURED",
    description: "Querying company data",
    color: "#1976D2",
    bg: "#E3F2FD",
  },
  analytical: {
    label: "ANALYTICAL",
    description: "Comparing across dataset",
    color: "#2E7D32",
    bg: "#E8F5E9",
  },
  narrative: {
    label: "NARRATIVE",
    description: "Reading company report",
    color: "#407775",
    bg: "#DAECEC",
  },
  novel: {
    label: "NOVEL",
    description: "Synthesizing insights",
    color: "#B8860B",
    bg: "#FFF8E1",
  },
  // Advisor (tenant-scoped chat) categories — without these every advisor
  // answer fell through to the NOVEL badge.
  metric_query: {
    label: "YOUR DATA",
    description: "Reading your platform figures",
    color: "#1976D2",
    bg: "#E3F2FD",
  },
  definition: {
    label: "REGULATION",
    description: "Citing regulatory texts",
    color: "#6A1B9A",
    bg: "#F3E5F5",
  },
  benchmark: {
    label: "BENCHMARK",
    description: "Comparing with sector peers",
    color: "#2E7D32",
    bg: "#E8F5E9",
  },
  drafting: {
    label: "DRAFTING",
    description: "Drafting a disclosure",
    color: "#AD1457",
    bg: "#FCE4EC",
  },
  levers: {
    label: "REDUCTION",
    description: "Finding reduction options",
    color: "#EF6C00",
    bg: "#FFF3E0",
  },
  out_of_scope: {
    label: "OUT OF SCOPE",
    description: "Outside the Advisor's remit",
    color: "#757575",
    bg: "#EEEEEE",
  },
}

const ClassificationBadge = ({ category, confidence }) => {
  const config = CATEGORY_CONFIG[category] || CATEGORY_CONFIG.novel

  return (
    <div
      style={{
        display: "inline-flex",
        alignItems: "center",
        gap: "6px",
        padding: "3px 10px",
        borderRadius: "12px",
        backgroundColor: config.bg,
        marginBottom: "8px",
      }}
    >
      <span
        style={{
          fontSize: "10px",
          fontWeight: "700",
          color: config.color,
          letterSpacing: "0.5px",
        }}
      >
        {config.label}
      </span>
      <span style={{ fontSize: "10px", color: "#707070" }}>
        {config.description}
      </span>
      {confidence != null && (
        <span
          style={{
            fontSize: "9px",
            color: "#999",
            marginLeft: "2px",
          }}
        >
          ({Math.round(confidence * 100)}%)
        </span>
      )}
    </div>
  )
}

export default ClassificationBadge
